module.exports = __webpack_public_path__ + "media/game_dial_01.c15327c8.mp4";